module.exports = __webpack_public_path__ + "static/media/undraw_medical_care_movn.095a1cc7.svg";